import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';

export type TransactionFilterValue = string | number | boolean | string[] | number[];

export interface TransactionDataRequestDTO {
  page: number;
  size: number;
  search: string;
  filters: Record<string, TransactionFilterValue>;
}

export interface PageResponse<T> {
  data: T[];
  recordsTotal: number;
  recordsFiltered: number;
}

export interface TransactionRow {
  [key: string]: unknown;
  id: number;
  transactionId?: string;
  terminalId?: string;
  solicitudPago?: number;
  transactionDateTime?: string;
  amountTransaction?: number;
  cardBrand?: string;
  cardType?: string;
  paymentMethod?: string;
  transactionContext?: string;
  transactionStatus?: string;
  acquirer?: string;
  card?: string;
  posEntryMode?: string;
  authorizationCode?: string;
  walletName?: string;
  transactionOriginType?: string;
  paymentProcessType?: string;
}

export interface IsoTransactionRow {
  [key: string]: unknown;
  id: number;
  referenceNumber?: string;
  terminalIdentification?: string;
  stan?: string;
  localTransactionDateTime?: string;
  amountTransaction?: number;
  brand?: string;
  processingCodeType?: string;
  posEntryModeType?: string;
  transactionStatus?: string;
  bin?: string;
  l4d?: string;
  authorizationCode?: string;
}

export interface GpTransactionRow {
  [key: string]: unknown;
  id: number;
  transactionId?: string;
  terminalId?: string;
  externalReference?: string;
  transactionDateTime?: string;
  amountTransaction?: number;
  transactionCurrencyCode?: string;
  transactionType?: string;
  transactionStatus?: string;
  cardBrand?: string;
  cardType?: string;
  posEntryMode?: string;
  card?: string;
  authorizationCode?: string;
  rrn?: string;
  walletName?: string;
}

@Injectable({ providedIn: 'root' })
export class TransactionApi {
  constructor(private readonly http: HttpClient) {}

  getHpgTransactions(request: TransactionDataRequestDTO): Observable<PageResponse<TransactionRow>> {
    return this.http
      .post<PageResponse<TransactionRow>>('/transaction/web/transaction/data', this.normalizeRequest(request))
      .pipe(timeout(30000));
  }

  getHpgDetail(id: number): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(`/transaction/web/transaction/${id}`);
  }

  getIsoTransactions(request: TransactionDataRequestDTO): Observable<PageResponse<IsoTransactionRow>> {
    return this.http
      .post<PageResponse<IsoTransactionRow>>('/iso/transaction/data', this.normalizeRequest(request))
      .pipe(timeout(30000));
  }

  getIsoDetail(id: number): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(`/iso/transaction/${id}`);
  }

  getGpTransactions(request: TransactionDataRequestDTO): Observable<PageResponse<GpTransactionRow>> {
    return this.http
      .post<PageResponse<GpTransactionRow>>('/gp-query/transaction/data', this.normalizeRequest(request))
      .pipe(timeout(30000));
  }

  getGpDetail(id: number): Observable<Record<string, unknown>> {
    return this.http.get<Record<string, unknown>>(`/gp-query/transaction/${id}`);
  }

  private normalizeRequest(request: TransactionDataRequestDTO): TransactionDataRequestDTO {
    return {
      page: Number(request.page ?? 0),
      size: Number(request.size ?? 10),
      search: request.search ?? '',
      filters: request.filters ?? {}
    };
  }
}
